import useTypedContext from "hooks/useTypedContext";

import { StackSettingsVendorComponentBaseProps } from "../types";
import StackSettingsVendorCloudFormationEdit from "./Edit";
import StackSettingsVendorCloudFormationView from "./View";
import { StackSettingsContextData } from "../../Context";

const StackSettingsVendorCloudFormation = (props: StackSettingsVendorComponentBaseProps) => {
  const { canUpdateStack } = useTypedContext(StackSettingsContextData);

  return canUpdateStack.result ? (
    <StackSettingsVendorCloudFormationEdit {...props} />
  ) : (
    <StackSettingsVendorCloudFormationView />
  );
};

export default StackSettingsVendorCloudFormation;
